import QRCode, { QRCodeToDataURLOptions } from 'qrcode';
import { useBuildType } from 'src/hooks/_use_build_type';
import { useSelector } from 'react-redux';
import { getCrmData, getCurrentLang } from 'src/store/app/selectors';
import { useIsDevMode } from 'src/hooks/app';
import { isNumeric } from 'src/helpers/isNumeric';
import { IComplex } from 'src/typings/complexes';
import { getMarketplaceLinkParams, getMarketplaceStaticLinkParams } from 'src/store/marketplace/selectors';
import { getLinkParams } from 'src/components/Marketplace/helpers';
import { useComplex } from 'src/hooks/app/use-complex';

export const useQRCode = () => {
  const { isCrossTable } = useBuildType();
  const { isDevMode } = useIsDevMode();
  const { isMarketplace } = useBuildType();
  const linkParams = useSelector(getMarketplaceLinkParams);
  const staticLinkParams = useSelector(getMarketplaceStaticLinkParams);
  const crmData = useSelector(getCrmData);
  const { complex } = useComplex();
  const currentLang = useSelector(getCurrentLang);
  const getQrCode = async (link: string, options?: QRCodeToDataURLOptions) => {
    let result = '';
    try {
      result = await QRCode.toDataURL(link, options);
    } catch (err) {
      result = '';
    }
    return result;
  };

  const getLink = (_complex?: Partial<IComplex>) => {
    if (isCrossTable || crmData) {
      return '';
    }
    const localComplex = _complex || complex;
    const string = new URL(document.URL).pathname.split('/');
    const complexShortName: string = string[string.length - 1];
    if ((localComplex && localComplex?.complexShortName?.length && !isNumeric(complexShortName)) || isDevMode) {
      let hash = '';
      if (isMarketplace && linkParams && staticLinkParams) {
        hash = getLinkParams(linkParams, staticLinkParams);
      }
      return `${getClientModuleAccessUrl(localComplex, currentLang)}${hash}`;
    }
    return '';
  };

  const getLinkMarketplace = (_complex: Partial<IComplex>) => {
    return getLink(_complex);
  };

  const getClientModuleAccessUrl = (_complex: Partial<IComplex> | null, lang: string): string => {
    if (_complex?.clientModuleAccessUrls?.length && _complex?.clientModuleAccessUrls[0]?.url) {
      return `${_complex?.clientModuleAccessUrls[0].url}`;
    }
    const _lang = lang.length ? `/${lang}` : '';
    return `https://flatshow.property${_lang}/${_complex?.complexShortName}#`;
  };

  return {
    getQrCode,
    getLink,
    getClientModuleAccessUrl,
    getLinkMarketplace,
  };
};
